import { render } from "./TenantConfigurationDeltaView.vue?vue&type=template&id=2f2bb2cb"
import script from "./TenantConfigurationDeltaView.vue?vue&type=script&lang=js"
export * from "./TenantConfigurationDeltaView.vue?vue&type=script&lang=js"

import "./TenantConfigurationDeltaView.vue?vue&type=style&index=0&id=2f2bb2cb&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__